/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Tip } from './Tip';
import {
    TipFromJSON,
    TipFromJSONTyped,
    TipToJSON,
} from './Tip';

/**
 * 
 * @export
 * @interface GetTipsResponse
 */
export interface GetTipsResponse {
    /**
     * 
     * @type {Array<Tip>}
     * @memberof GetTipsResponse
     */
    data?: Array<Tip>;
}

/**
 * Check if a given object implements the GetTipsResponse interface.
 */
export function instanceOfGetTipsResponse(value: object): value is GetTipsResponse {
    let isInstance = true;

    return isInstance;
}

export function GetTipsResponseFromJSON(json: any): GetTipsResponse {
    return GetTipsResponseFromJSONTyped(json, false);
}

export function GetTipsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTipsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TipFromJSON)),
    };
}

export function GetTipsResponseToJSON(value?: GetTipsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TipToJSON)),
    };
}

